export const TIME_IS_UP_INIT_STATE = {
    header: '',
    description: '',
    imageSrc: '',
    imageDisclaimer: '',
    isRetryButton: false,
    isActionButton: false,
    actionButtonText: '',
    actionButtonLink: '',
}
